import PropTypes from 'prop-types';

import Stack from '@zenbusiness/zui/Stack';

import * as Styled from './Carousel.styles';
import CarouselControls from './CarouselControls';

function CarouselContainer({
  children,
  emblaRef,
  handleNextButtonOnClick = () => {},
  handlePrevButtonOnClick = () => {},
  progressState = {}
}) {
  return (
    <Stack aria-label="Carousel" gap={2} role="region">
      <Styled.Carousel ref={emblaRef} aria-atomic={false} aria-live="off">
        <Styled.Container>{children}</Styled.Container>
      </Styled.Carousel>

      <CarouselControls
        handlePrevButtonOnClick={handlePrevButtonOnClick}
        handleNextButtonOnClick={handleNextButtonOnClick}
        progressState={progressState}
      />
    </Stack>
  );
}

CarouselContainer.propTypes = {
  emblaRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
  ]),
  handlePrevButtonOnClick: PropTypes.func,
  handleNextButtonOnClick: PropTypes.func,
  progressState: PropTypes.shape({
    autoplayDuration: PropTypes.number,
    currentSlide: PropTypes.number,
    isAutoplay: PropTypes.bool,
    totalSlides: PropTypes.number
  })
};

export default CarouselContainer;
